import React from 'react';
import { useI18n } from '@udemy/i18n';
import { Button, IconButton } from '@udemy/react-core-components';
import { Loader } from '@udemy/react-reveal-components';
import { UnwishlistedIcon, WishlistedIcon } from './unwishlisted-icon.react-component';
export const WishlistButton = props => {
  const {
    isWishlisted,
    isLoading,
    onClick,
    round = false,
    size = 'medium',
    wishlistCta = undefined,
    wishlistedCta = null,
    labelPosition = 'left',
    square = false,
    givenButtonProps
  } = props;
  const {
    gettext
  } = useI18n();
  const buttonProps = {
    udStyle: 'secondary',
    size,
    onClick,
    ...givenButtonProps,
    disabled: givenButtonProps === null || givenButtonProps === void 0 ? void 0 : givenButtonProps.disabled,
    'aria-pressed': isWishlisted,
    'aria-label': wishlistCta
  };
  const WishlistIcon = isWishlisted ? WishlistedIcon : UnwishlistedIcon;
  const loader = isLoading ? /*#__PURE__*/React.createElement(Loader, {
    color: "inherit"
  }) : null;
  const wishlistCtaText = wishlistCta !== null && wishlistCta !== void 0 ? wishlistCta : gettext('Add to wishlist');
  const wishlistedCtaText = wishlistedCta !== null && wishlistedCta !== void 0 ? wishlistedCta : gettext('Wishlisted');
  const label = isWishlisted ? wishlistedCtaText : wishlistCtaText;
  if (square || round) {
    return /*#__PURE__*/React.createElement(IconButton, Object.assign({}, buttonProps, {
      round: round
    }), loader !== null && loader !== void 0 ? loader : /*#__PURE__*/React.createElement(WishlistIcon, {
      color: "inherit",
      label: false
    }));
  }
  return /*#__PURE__*/React.createElement(Button, buttonProps, loader !== null && loader !== void 0 ? loader : /*#__PURE__*/React.createElement(React.Fragment, null, labelPosition == 'left' && /*#__PURE__*/React.createElement("span", null, label), /*#__PURE__*/React.createElement(WishlistIcon, {
    color: "inherit",
    size: labelPosition == 'right' ? size : 'small',
    label: false
  }), labelPosition == 'right' && /*#__PURE__*/React.createElement("span", null, label)));
};
//# sourceMappingURL=wishlist-button.react-component.js.map